import {
    NgModule
} from '@angular/core';
import {
    CommonModule
} from '@angular/common';
import {
    FormsModule
} from '@angular/forms';
import {
    RouterModule
} from '@angular/router';
import {
    IonicModule
} from '@ionic/angular';
import {
    ApperyioTranslateModule
} from '../../scripts/apperyio/translate_module';
import {
    ApperyioDeclarablesModule
} from '../../scripts/apperyio/declarables/apperyio.declarables.module';
import {
    DeviceList
} from './DeviceList';
import {
    PipesModule
} from '../../scripts/pipes.module';
import {
    DirectivesModule
} from '../../scripts/directives.module';
import {
    ComponentsModule
} from '../../scripts/components.module';
import {
    CustomModulesModule
} from '../../scripts/custom-modules.module';
@NgModule({
    declarations: [
        DeviceList
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
        DirectivesModule,
        ComponentsModule,
        ApperyioDeclarablesModule,
        CustomModulesModule, RouterModule,
        ApperyioTranslateModule
    ],
    exports: [
        DeviceList
    ],
    entryComponents: [
        DeviceList
    ]
})
export class DeviceListComponentModule {}